import React from 'react'
import { CircleFlag } from 'react-circle-flags'
import { useSelector } from 'react-redux'
import { NavLink, useLocation } from 'react-router-dom'
import { createAbsoluteUrl } from 'utils/constants'
import { selectUser } from 'app/slice/selectors'
import { ActivateDialog } from './activate-dialog'

import { Button } from 'app/components/ui/button'
import { NavigationMenu, NavigationMenuList, NavigationMenuItem, NavigationMenuTrigger, NavigationMenuContent, NavigationMenuLink } from 'app/components/ui/navigation-menu'

const navigationItems = [
  {
    label: "Coverage",
    items: [
      { to: "/network-coverage", label: "Domestic Coverage" },
      { to: "/international-calling", label: "International Calling" },
      { to: "/international-calling#international-roaming", label: "International Roaming" },
    ]
  },
  {
    label: "Support",
    items: [
      { to: "/imei-check", label: "IMEI Check" },
      { to: "https://vlemobile.tawk.help", label: "Knowledge Base", target: "_blank" },
      { to: "/about-esim", label: "About eSIM" },
      { to: "/how-vle-mobile-works", label: "How VLE Mobile Works" },
      // { to: "/faq", label: "FAQ" },
      // { to: "/resource-center", label: "Blog" },
      // { to: "/support-center", label: "Contact Us" },
      // { to: "/support-tickets", label: "Support Tickets" },
      { to: createAbsoluteUrl("/faq"), label: "FAQ", target: "_self" },
      { to: createAbsoluteUrl("/resource-center"), label: "Blog", target: "_self" },
      { to: createAbsoluteUrl("/support-center"), label: "Contact Us", target: "_self" },
      { to: createAbsoluteUrl("/support-tickets"), label: "Support Tickets", target: "_self" },
      { to: "/about-us", label: "About Us" },
    ]
  }
];

export const HelpContactBar = () => {
  const user = useSelector(selectUser);
  const location = useLocation();
  
  return (
    <div className="h-8 sm:h-10 lg:h-[3.125rem] border-b border-[#D9D9D9]">
      <div className="flex items-center justify-center lg:justify-between max-w-[86rem] h-full px-5 sm:px-6 md:px-7 lg:px-5 mx-auto">
        <div className="flex gap-1 sm:gap-1.5 lg:gap-2 items-center">
          <p className="text-[#464646] [@media(max-width:375px)]:text-[0.72rem] text-xs sm:text-sm md:text-[0.925rem] lg:text-base font-medium leading-4 sm:leading-[1.125rem] lg:leading-5">
            <span>Questions?</span>{" "}
            <a
              className="hover:text-black font-bold cursor-pointer underline decoration-solid decoration-skip-ink decoration-[auto] underline-offset-[auto] [text-underline-position:from-font]"
              href="/schedule-call"
              target="_blank"
              rel="noopener noreferrer"
            >
              Schedule call
            </a> <span>or call us</span>
          </p>
          <Button type="button" variant="ghost" className="hover:bg-transparent gap-0.5 sm:gap-1 lg:gap-1.5" onClick={() => window.location.href = "tel:18448536624"}>
            <img src="/assets/phone-call.svg" alt="Phone Call" className="flex-shrink-0 w-2.5 sm:w-3 lg:w-3.5 h-[0.5625rem] sm:h-[0.6875rem] lg:h-[0.8125rem]" />
            <span className="text-[#FE4D01] text-xs sm:text-sm md:text-[0.925rem] lg:text-base font-extrabold leading-4 sm:leading-[1.125rem] lg:leading-5">
              844-VLEMOBILE
            </span>
          </Button>
        </div>
        <div className="hidden items-center lg:flex">
          <div className="hidden pr-1.5 sm:pr-2 md:pr-3 lg:pr-4 border-r border-[#D9D9D9] md:block">
            {/* <NavLink
              to="/activate"
              className={({ isActive }) =>
                `text-xs sm:text-[0.825rem] lg:text-sm font-normal leading-4 sm:leading-[1.125rem] lg:leading-5 hover:text-[#FE4D01] whitespace-nowrap ${
                  isActive
                    ? "text-[#1D1D1B]"
                    : "text-[#464646]"
                }`
              }
            >
              Activate
            </NavLink> */}
            <ActivateDialog />
          </div>
          {/* {!user && (
            <div className="hidden px-1.5 sm:px-2 md:px-3 lg:px-4 border-r border-[#D9D9D9] md:block">
              <NavLink
                to="/quick-recharge"
                className={({ isActive }) =>
                  `text-xs sm:text-[0.825rem] lg:text-sm font-normal leading-4 sm:leading-[1.125rem] lg:leading-5 hover:text-[#FE4D01] whitespace-nowrap ${
                    isActive
                      ? "text-[#1D1D1B]"
                      : "text-[#464646]"
                  }`
                }
              >
                Quick Recharge
              </NavLink>
            </div>
          )} */}
          <NavigationMenu className="hidden sm:block">
            <NavigationMenuList className="gap-0">
              {navigationItems.map((navItem, index) => (
                <NavigationMenuItem key={navItem.label} className={`px-1.5 sm:px-2 md:px-3 lg:px-4 border-r border-[#D9D9D9] ${index === navigationItems.length - 1 ? 'border-r-0' : ''}`}>
                  <NavigationMenuTrigger className="bg-transparent hover:bg-transparent focus:bg-transparent data-[state=open]:bg-transparent data-[state=open]:hover:bg-transparent data-[state=open]:focus:bg-transparent w-fit h-4 p-0 text-[#464646] text-[0.785rem] xl:text-sm font-normal leading-4 sm:leading-[1.125rem] lg:leading-5 hover:text-[#FE4D01] data-[state=open]:text-[#1D1D1B] whitespace-nowrap">
                    {navItem.label}
                  </NavigationMenuTrigger>
                  <NavigationMenuContent className="p-0.5 pr-1 pb-1 md:w-56">
                    <ul className="grid gap-0.5">
                      {navItem.items.map((subItem) => (
                        <li key={subItem.to}>
                          {subItem.target ? (
                            <NavigationMenuLink className="hover:bg-[#FE4D0114] px-2.5 lg:px-3 xl:px-3.5 py-1 lg:py-1.5 text-[0.785rem] xl:text-sm leading-5 whitespace-nowrap text-[#353531] hover:text-[#353531] font-medium">
                              <a
                                href={subItem.to}
                                target={subItem.target || '_blank'}
                                rel="noopener noreferrer"
                                className="hover:text-[#1D1D1B] focus:text-[#1D1D1B]"
                              >
                                {subItem.label}
                              </a>
                            </NavigationMenuLink>
                          ) : (
                            <NavLink to={subItem.to}>
                              {() => {
                                const currentPath = location.pathname + (location.hash || '');
                                const isExactMatch = currentPath === subItem.to;
                                
                                return (
                                  <NavigationMenuLink 
                                    className={`relative hover:bg-[#FE4D0114] focus:bg-[#FE4D0114] data-[active=true]:bg-[#FE4D0114] data-[active=true]:hover:bg-[#FE4D0114] data-[active=true]:focus:bg-[#FE4D0114] px-2.5 lg:px-3 xl:px-3.5 py-1 lg:py-1.5 text-[0.785rem] xl:text-sm leading-5 whitespace-nowrap text-[#353531] hover:text-[#353531] focus:text-[#353531] data-[active=true]:text-[#FE4D01] font-medium ${isExactMatch ? 'data-[active=true]' : ''}`}
                                    data-active={isExactMatch}
                                  >
                                    {subItem.label}
                                    {isExactMatch && <img src="/assets/tick-orange.svg" alt="Tick" className="shrink-0 size-4 xl:size-[1.125rem] absolute right-2 lg:right-2.5 xl:right-3 top-1/2 -translate-y-1/2" aria-hidden="true" />}
                                  </NavigationMenuLink>
                                );
                              }}
                            </NavLink>
                          )}
                        </li>
                      ))}
                    </ul>
                  </NavigationMenuContent>
                </NavigationMenuItem>
              ))}
            </NavigationMenuList>
          </NavigationMenu>
          {/* <Button type="button" variant="ghost" className="hidden sm:inline-flex hover:bg-transparent hover:text-[#464646] gap-1 sm:gap-1.5 pl-1.5 sm:pl-2 md:pl-3 lg:pl-4 rounded-none cursor-default text-[#464646] text-xs sm:text-[0.825rem] lg:text-sm font-normal leading-4 sm:leading-[1.125rem] lg:leading-5">
            <CircleFlag countryCode="es" className="size-2.5 sm:size-3 lg:size-4 rounded-full flex-shrink-0 mb-0.5" />
            <span className="hidden md:inline-block hover:text-[#1D1D1B] cursor-pointer">Español</span>
            <span className="md:hidden hover:text-[#1D1D1B]">ES</span>
          </Button> */}
        </div>
      </div>
    </div>
  )
}
